/* ============================================================
   KISHI KAISEI — ajout depuis la vente complémentaire du panier.
   ------------------------------------------------------------
   Le bloc kk-cross est rendu a l'interieur du formulaire du panier :
   ses cartes ne peuvent donc pas etre des <form>, les formulaires
   imbriques sont supprimes par le navigateur. D'ou ce petit script.

   Il ne reimplemente rien : apres l'ajout, il clique sur l'icone panier
   de l'en-tete, ce qui declenche le Cart.refresh(true) de app.js. Le
   thème garde donc un seul moteur de panier, et le tiroir se rafraichit
   exactement comme apres un ajout depuis une fiche produit.

   Ecouteur delegue au niveau du document : il survit au remplacement du
   contenu du tiroir par la Section Rendering API, contrairement a un
   ecouteur pose sur les boutons eux-memes.
   ============================================================ */
(function () {
  'use strict';

  if (window.__kkCross) { return; }
  window.__kkCross = true;

  var routes = window.routes || {};

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kk-cross-add]');
    if (!btn) { return; }

    e.preventDefault();
    e.stopPropagation();

    var vid = btn.getAttribute('data-vid');
    if (!vid) { return; }

    var bloc = btn.closest('.kk-cross');
    var err = bloc ? bloc.querySelector('[data-kk-cross-err]') : null;
    if (err) { err.hidden = true; }

    var libelle = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout…';

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (corps) {
          if (!r.ok) { throw corps; }
          return corps;
        });
      })
      .then(function () {
        /* Page panier : la liste des articles doit etre reconstruite. */
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        /* Tiroir : on passe par le mecanisme du theme. */
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) {
          toggle.click();
        } else {
          window.location.href = routes.cart_url || '/cart';
        }
      })
      .catch(function (bug) {
        btn.disabled = false;
        btn.textContent = libelle;
        var message = (bug && (bug.description || bug.message)) || "Impossible d'ajouter cet article.";
        if (err) {
          err.textContent = message;
          err.hidden = false;
        } else {
          window.alert(message);
        }
      });
  });
})();